import { render, staticRenderFns } from "./ApplicationDocumentsBlock.vue?vue&type=template&id=21c46e70"
import script from "./ApplicationDocumentsBlock.vue?vue&type=script&lang=js"
export * from "./ApplicationDocumentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports